import { applySdkMetadata } from '@sentry/core';
import { init as init$1 } from '@sentry/react';
import { getIntegrationsFromOptions } from './utils/integrations.js';

/**
 * Inits the Sentry Gatsby SDK.
 */
function init(options) {
  applySdkMetadata(options, 'gatsby');
  const integrations = getIntegrationsFromOptions(options);
  init$1({
    ...options,
    integrations,
  });
}

export { init };
//# sourceMappingURL=sdk.js.map
